import { isNotNullishOrEmpty } from "@grindex-common/helpers/typeHelpers";
import { KeywordQuery } from "../keyword-query";
import type { DateQuery } from "./DateQuery";

export default class EventQuery extends KeywordQuery implements DateQuery {
	constructor() {
		super();
		this.queryData["startdate"] = null;
		this.queryData["enddate"] = null;
		this.queryData["keyword"] = null;

		// @ts-expect-error unsure of type of isArchive
		const isArchive = window.config.search.isArchive === "True";

		this.queryData.set("isarchive", isArchive);
	}

	setDates(startDate: string | null, endDate: string | null) {
		this.queryData["startdate"] = startDate;
		this.queryData["enddate"] = endDate;
		this.resetPage();
	}

	hasStartDate(): boolean {
		const startDate = this.queryData["startdate"];
		return isNotNullishOrEmpty(startDate);
	}

	hasEndDate(): boolean {
		const endDate = this.queryData["enddate"];
		return isNotNullishOrEmpty(endDate);
	}
}
